export var IdEventSoundCore;
(function (IdEventSoundCore) {
    IdEventSoundCore[IdEventSoundCore["Music"] = 0] = "Music";
    // Base buildings
    IdEventSoundCore[IdEventSoundCore["BuildingCelebration"] = 1] = "BuildingCelebration";
    IdEventSoundCore[IdEventSoundCore["BuildingFinish"] = 2] = "BuildingFinish";
    IdEventSoundCore[IdEventSoundCore["BuildingStartMove"] = 3] = "BuildingStartMove";
    IdEventSoundCore[IdEventSoundCore["BuildingFinishMove"] = 4] = "BuildingFinishMove";
    IdEventSoundCore[IdEventSoundCore["BuildingRotate"] = 5] = "BuildingRotate";
    IdEventSoundCore[IdEventSoundCore["BuildingProductionFinish"] = 6] = "BuildingProductionFinish";
    // Production
    IdEventSoundCore[IdEventSoundCore["ProduceFeed"] = 7] = "ProduceFeed";
    IdEventSoundCore[IdEventSoundCore["ProduceFertilizer"] = 8] = "ProduceFertilizer";
    IdEventSoundCore[IdEventSoundCore["ProduceProduct"] = 9] = "ProduceProduct";
    IdEventSoundCore[IdEventSoundCore["ProduceSow"] = 10] = "ProduceSow";
    // Outskirts
    IdEventSoundCore[IdEventSoundCore["WatertowerCollect"] = 11] = "WatertowerCollect";
    IdEventSoundCore[IdEventSoundCore["MarketContractTrash"] = 12] = "MarketContractTrash";
    IdEventSoundCore[IdEventSoundCore["MarketContractStart"] = 13] = "MarketContractStart";
    IdEventSoundCore[IdEventSoundCore["MarketContractLoop"] = 14] = "MarketContractLoop";
    IdEventSoundCore[IdEventSoundCore["MarketContractFinish"] = 15] = "MarketContractFinish";
    // Generic
    IdEventSoundCore[IdEventSoundCore["ButtonClick"] = 16] = "ButtonClick";
    IdEventSoundCore[IdEventSoundCore["ButtonPagerClick"] = 17] = "ButtonPagerClick";
    IdEventSoundCore[IdEventSoundCore["LevelUp"] = 18] = "LevelUp";
    IdEventSoundCore[IdEventSoundCore["QuestComplete"] = 19] = "QuestComplete";
    IdEventSoundCore[IdEventSoundCore["SpendGold"] = 20] = "SpendGold";
    // Dog
    IdEventSoundCore[IdEventSoundCore["DogIdlePlayful"] = 21] = "DogIdlePlayful";
    IdEventSoundCore[IdEventSoundCore["DogSniff"] = 22] = "DogSniff";
    // Items
    IdEventSoundCore[IdEventSoundCore["ItemCollect"] = 23] = "ItemCollect";
    IdEventSoundCore[IdEventSoundCore["ItemSell"] = 24] = "ItemSell";
    IdEventSoundCore[IdEventSoundCore["ItemSpawn"] = 25] = "ItemSpawn";
    IdEventSoundCore[IdEventSoundCore["None"] = 26] = "None";
})(IdEventSoundCore || (IdEventSoundCore = {}));



//////////////////
// WEBPACK FOOTER
// ./src/utils/sound/IdEventSoundCore.ts
// module id = 51
// module chunks = 3